import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CreateScreeningService } from '@/app/pages/screening-brief-create/services/create-screening/create-screening.service';
import { ImageService } from '@/app/services/image/image.service';
import { LdgImgComponent } from '@/app/atoms/ldg-img/ldg-img.component';
import { groupRestrictionsByCategory } from '../../screening-brief.utils';
import { ScreeningWindow } from '../screening-window/screening-window';

/**
 * Wizard step 5 — a last read of the brief before the pre-flight check.
 *
 * The screening window lives here rather than on its own step: the API needs `screenUntil`, but the
 * design has no step for it, and "how far back do we look" reads naturally as part of the summary.
 */
@Component({
  selector: 'sbs-screening-review',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LdgImgComponent, ScreeningWindow],
  templateUrl: './screening-review.html',
})
export class ScreeningReview {

  readonly createScreeningService = inject(CreateScreeningService);
  readonly imageService = inject(ImageService);

  readonly briefName = computed(() => this.createScreeningService.basicInfoModel().briefTitle.trim());

  readonly restrictionGroups = computed(() =>
    groupRestrictionsByCategory(this.createScreeningService.restrictions()),
  );
}
